// #209: Mengenfelder dürfen während der Eingabe leer sein. `null` steht für
// "noch keine Menge"; die Flows blockieren das Buchen, statt still einen
// alten Wert oder das Minimum zu verwenden.

export function parseQuantityInput(raw, { min = 0, max = 9999 } = {}) {
    const text = String(raw ?? "").trim();
    if (text === "") return null;
    const parsed = Number.parseInt(text, 10);
    if (!Number.isFinite(parsed) || parsed < min) return null;
    return Math.min(max, parsed);
}

export function stepQuantity(value, delta, { min = 0, max = 9999 } = {}) {
    const base = value ?? 0;
    return Math.max(min, Math.min(max, base + delta));
}

export function hasQuantity(value, { min = 1 } = {}) {
    return Number.isInteger(value) && value >= min;
}
